import React, { useState, useEffect } from 'react';import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { addAttendance } from '../../../redux/api/attendanceApi/AttendanceApi';
import { addAttendanceAction } from '../../../redux/reduxSlice/AttendanceSlice';
import { updateAttendance } from '../../../redux/api/attendanceApi/AttendanceApi';
import { updateAttendanceAction } from '../../../redux/reduxSlice/AttendanceSlice';
import ProgressBar from '../../../utils/progressBar/ProgressBar';

import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel
} from '@chakra-ui/react';

function AttendanceForm(props) {
  const [showProgressBar, setShowProgressBar] = useState(false);
  const dispatch = useDispatch();
  const [submitDisabled, setSubmitDisabled] = useState(false)
  const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, timesheetROWID, onNewAttendanceAdded } = props;

  const originalFormData = {
    dates: "",    
    firstIn: "",
    lastOut: "",
    totalHours: "",
    paidBreak: "",
    payableHours: "",
    status: "",
    shifts: "",
    email: "",
    netHours: "",
    earlyEntry: "",
    lateEntry: "",
    lateExit: "",
    earlyExit: "",
    employeeName: "",
    employeeId: ""
  }

  const [status, setStatus] = useState([])
  const [formData, setFormData] = useState(originalFormData);

  const { closeDrawer } = props;
  const handleOnClose = () => {
    closeDrawer();
    setFormData(originalFormData); // Reset the form data
    if (isUpdateMode) {
      setIsUpdateMode(false); // Reset the mode to create mode
    }
  };

  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  // Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.employeeName === "" ||formData.lastOut === "" || formData.firstIn === "" ||formData.employeeId === ""  ) {
      toast.error("Please fill all the required fields")
      return
    }
    console.log(formData)
    setShowProgressBar(true)
    addAttendance(formData)
      .then((response) => {
        onNewAttendanceAdded()
        console.log("Response - ", response);
        if (response.data.success) {
          let ROWID = response.data.ROWID
          dispatch(addAttendanceAction({ ROWID, formData }));
          console.log(response)
          setFormData(originalFormData)
          setShowProgressBar(false)
          toast.success("Attendance added successfully!");
          handleOnClose();
          setFormData(originalFormData)
          setShowProgressBar(false)
        }
        else {
          toast.error("Unable to add Attendance , Please try again!")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        toast.error("Failed to add Attendance. Please try again.");
      });
  }


  // UpdateMode Use-effect
  useEffect(() => {
    console.log(isUpdateMode, dataToEdit)
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...props.dataToEdit,
      }
      ))
    }
    console.log(formData)
  }, [isUpdateMode, dataToEdit]);

  useEffect(() => {
    console.log(formData)
  }, [formData])


  // Handle Update Function
  const handelOnUpdate = (e) => {
    e.preventDefault()
    setShowProgressBar(true)
    updateAttendance(formData).then((response) => {
      console.log({ response })
      if (response.data.success) {
        setFormData((prev) => ({
          ...prev, ROWID: response?.data.ROWID
        }))
        dispatch(updateAttendanceAction(formData))
        toast.success("Attendance Updated SuccesFully !!")
      }
      setTimeout(() => {
        handleOnClose();
        setShowProgressBar(false);
        setSubmitDisabled(false)
      }, 300);
    }).catch((error) => {
      console.log(error)
      toast.error("Attendance Updation Failed !")
    }).finally(() => {
      setSubmitDisabled(false);
    });
  }


  // custom style for lookup
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "20px",
      border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),
    placeholder: (styles) => ({
      ...styles,
      color: 'gray',
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: 'black',
      backgroundColor: 'white',
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected
        ? '#f1e9e9;'
        : isFocused
          ? '#f1e9e9;'
          : 'white',
      color: isSelected ? '#666' : '#333',
    }),
  }

  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{isUpdateMode ? "Update Attendance" : "Create Attendance"}</DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <div className='card'>
              <div className='card-body'>
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Employee Name' name='employeeName' value={formData?.employeeName} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Employee Name<span style={{color: 'red'}}>*</span></FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Employee Id' name='employeeId' value={formData?.employeeId} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Employee Id<span style={{color: 'red'}}>*</span></FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='email' style={{ outline: "none", border: "none" }} placeholder='Email Id' name='email' value={formData?.email} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Email Id</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Date' name='dates' value={formData?.dates} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Dates</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='First In' name='firstIn' value={formData?.firstIn} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">First In<span style={{color: 'red'}}>*</span></FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Last Out' name='lastOut' value={formData?.lastOut} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Last Out<span style={{color: 'red'}}>*</span></FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Payable Hours' name='payableHours' value={formData?.payableHours} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Payable Hours</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Total Hours' name='totalHours' value={formData?.totalHours} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Total Hours</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Paid Break' name='paidBreak' value={formData?.paidBreak} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Paid Break</FormLabel>
                </div>
                {/* <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select name='status' options={status} defaultValue={status.find((item) => (item.value === formData?.status))} onChange={(option) => { setFormData(prevFormData => ({ ...prevFormData, status: option.value })) }} styles={customStyle} />
                  <FormLabel className="small-label ps-3">Status</FormLabel>
                </div> */}
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                <select className=' rounded' type='text' placeholder=" Status" style={{ width: '100%',outline:"none" }}   onChange={handleChange}> 
                <option value="None">None</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Backlog">Backlog</option>
                    </select>
                </div>
                  <FormLabel className="small-label ps-3">Status</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Early Entry' name='earlyEntry' value={formData?.earlyEntry} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Early Entry</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Late Entry' name='lateEntry' value={formData?.lateEntry} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Late Entry</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Early Exit' name='earlyExit' value={formData?.earlyExit} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Early Exit</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='time' style={{ outline: "none", border: "none" }} placeholder='Late Exit' name='lateExit' value={formData?.lateExit} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Late Exit</FormLabel>
                </div>
              </div>
            </form>
            </div></div>
          </DrawerBody>
          <center><DrawerFooter style={{ display: 'inline-block' }} >
            <div className='gap-3 d-flex'>
              <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                Cancel
              </button>
              <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default AttendanceForm;